import { ReactNode } from "react";
import { SvgIcon } from "@mui/material";
import styles from "./ErrorMessage.module.css";
import XCircle from "./images/x-circle.svg?react";

export function CoreErrorMessage({ children }: { children: ReactNode }) {
	return (
		<div className={styles.message}>
			<SvgIcon className={styles.icon}>
				<XCircle />
			</SvgIcon>
			<div>{children}</div>
		</div>
	);
}
